<script>
import ResumeTemp1 from "../templates/resume/ResumeTemp1.vue";
import ResumeTemp2 from "../templates/resume/ResumeTemp2.vue";
import ResumeTemp3 from "../templates/resume/ResumeTemp3.vue";
import ResumeTemp4 from "../templates/resume/ResumeTemp4.vue";
import ResumeTemp5 from "../templates/resume/ResumeTemp5.vue";
import ResumeTemp6 from "../templates/resume/ResumeTemp6.vue";
import ResumeTemp7 from "../templates/resume/ResumeTemp7.vue";
import SelectDropdown from "../SelectDropdown.vue";
import InfoCard from "../InfoCard.vue";
import StyleBox from "../StyleBox.vue";
import ColorSchemeBox from "../ColorSchemeBox.vue";
import ProjectsDropdown from "../ProjectsDropdown.vue";
import InputField from "../InputField.vue";
import PreviewTemplates from "../PreviewTemplates.vue";
import { isResumeReady } from "@/utils/proposalValidation";
import img1 from "@/assets/images/templates/ResumeTemp1.png";
import img2 from "@/assets/images/templates/ResumeTemp2.png";
import img3 from "@/assets/images/templates/ResumeTemp3.png";
import img4 from "@/assets/images/templates/ResumeTemp4.png";
import img5 from "@/assets/images/templates/ResumeTemp5.png";
import img6 from "@/assets/images/templates/ResumeTemp6.png";
import img7 from "@/assets/images/templates/ResumeTemp7.png";
import { arrowDownIcon } from "@/utils/proposalIcons";
import AppButton from "../AppButton.vue";
import util from "@/utils/util.js";

export default {
    name: "StepResume",
    components: {
        ResumeTemp1, ResumeTemp2, ResumeTemp3, ResumeTemp4, ResumeTemp5, ResumeTemp6, ResumeTemp7,
        SelectDropdown,
        InfoCard,
        StyleBox,
        ColorSchemeBox,
        ProjectsDropdown,
        InputField,
        PreviewTemplates,
        AppButton,
    },
    props: {
        proposal: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            expandedMemberId: null,
            expandedBlockId: this.proposal.resume.blocks && this.proposal.resume.blocks[0] ? this.proposal.resume.blocks[0].id : null,
            memberSearchQuery: "",
            projectErrorMessages: {},
            memberErrorMessages: {},
            isGeneratingMembers: {},
            TemplateList: [
                {
                    label: '1- Display 1 resume per page with "Role Description" & "Experience" in sidebar and projects on right side',
                    value: 1,
                    preview: img1,
                    orientation: "portrait",
                    style: this.getTemplateStyle(1)
                },
                {
                    label: '2- Display 1 resume per page with "Education", "Certifications" and "Expereince" in sidebar and projects on right side',
                    value: 2,
                    preview: img2,
                    orientation: "portrait",
                    style: this.getTemplateStyle(2)
                },
                {
                    label: '3- Display 2 resumes per page with "Role Description" & "Experience" in sidebar and projects on right side',
                    value: 3,
                    preview: img3,
                    orientation: "portrait",
                    style: this.getTemplateStyle(3)
                },
                {
                    label: '4- Display 2 resumes per page with "Education", "Certifications" and "Expereince" in sidebar and projects on right side',
                    value: 4,
                    preview: img4,
                    orientation: "portrait",
                    style: this.getTemplateStyle(4)
                },
                {
                    label: '5- Display 1 resume per page with "Education", "Certifications" and "Expereince" in sidebar and "Role Description" and projects on right side',
                    value: 5,
                    preview: img5,
                    orientation: "portrait",
                    style: this.getTemplateStyle(5)
                },
                {
                    label: '6- Display 2 resumes per page with "Education", "Certifications" and "Expereince" in sidebar and "Role Description" and projects on right side',
                    value: 6,
                    preview: img6,
                    orientation: "portrait",
                    style: this.getTemplateStyle(6)
                },
                {
                    label: '1- Display 1 resume per page in Landscape with "Education", "Certifications", "Expereince" and "Role Description" in sidebar and projects on right side',
                    value: 7,
                    preview: img7,
                    orientation: 'landscape',
                    style: this.getTemplateStyle(7)
                }
            ],
            arrowDownIcon,
            debouncedMemberSearch: null
        };
    },
    created() {
        this.debouncedMemberSearch = this.debounce(() => {
            this.fetchMembersList(1);
        }, 500);
    },
    computed: {
        members() { return (this.$store.state.members && this.$store.state.members.data) || []; },
        membersPagination() { return (this.$store.state.members && this.$store.state.members.pagination) || {}; },
        MembersLoading() { return this.$store.state.loading.member; },
        membersList() {
            return this.members
                .map((item) => ({ label: item.teamMemberName, value: item.teamMemberId }))
                .filter(Boolean);
        },
        canPaginateMembers() { return ((this.membersPagination && this.membersPagination.page) || 0) < ((this.membersPagination && this.membersPagination.totalPages) || 0); },
        previewText() {
            const blocks = this.proposal.resume.blocks || [];
            if (!blocks.length) return "Add a block to preview";

            for (let i = 0; i < blocks.length; i++) {
                const block = blocks[i];
                const t = block.template;
                const blockLabel = `Block ${i + 1}`;

                if (!t) return `${blockLabel}: Select template to preview`;
                if (!block.members || block.members.length === 0) return `${blockLabel}: Select minimum one member to preview`;
                if (block.members.some((m) => !m.projects || m.projects.length === 0)) return `${blockLabel}: Select minimum one project for each member to preview`;

                if ((t == 1 || t == 3 || t == 5 || t == 6 || t == 7) && block.members.some((m) => !m.whyTeamMember || m.whyTeamMember.trim() === "")) {
                    return `${blockLabel}: Generate introduction response for each team member to preview`;
                }

                if (block.members.some((m) => m.projects.some((p) => (p.projectDetails || "").length > 200))) {
                    return `${blockLabel}: One or more project details exceed 200 characters. Please shorten them to preview.`;
                }

                if (block.members.some((m) => m.projects.some((p) => !p.projectDetails || p.projectDetails.trim() === ""))) {
                    return `${blockLabel}: Generate response for 'Project Scope' for each project to preview`;
                }

                if ((t === 3 || t === 4) && block.members.length < 2) {
                    return `${blockLabel}: Select two team members for this template or select template ${t === 3 ? '1' : '2'}`;
                }
            }
            return "";
        },
        isPreviewable() { return isResumeReady(this.proposal.resume); }
    },
    watch: {
        proposal: {
            handler(newVal) {
                if (newVal.resume && !newVal.resume.blocks) {
                    this.$set(newVal.resume, 'blocks', [
                        {
                            id: "block_1",
                            template: newVal.resume.template || "",
                            style: newVal.resume.style || null,
                            projectsPerPage: newVal.resume.projectsPerPage || 6,
                            members: newVal.resume.members || [],
                        }
                    ]);
                }
            },
            deep: true,
            immediate: true
        },
        memberSearchQuery() {
            this.debouncedMemberSearch();
        },
        'proposal.resume': {
            handler(newVal) {
                if (newVal.blocks) {
                    newVal.blocks.forEach(block => {
                        block.title = newVal.title;
                        block.opprName = newVal.opprName;
                        block.logo = newVal.logo;
                        block.submittedBy = newVal.submittedBy;
                    });
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        toggleMember(id) {
            if (this.expandedMemberId !== id && !this.$store.state.memberProjects[id]) {
                this.$store.dispatch("fetchProjects", { teamMemberId: id });
            }
            this.expandedMemberId = this.expandedMemberId === id ? null : id;
        },
        debounce(fn, delay) {
            let timeoutId;
            return (...args) => {
                if (timeoutId) clearTimeout(timeoutId);
                timeoutId = setTimeout(() => {
                    fn(...args);
                }, delay);
            };
        },
        async fetchMembersList(page = 1) {
            await this.$store.dispatch("fetchMembers", {
                page,
                search: this.memberSearchQuery,
            });
        },
        handleMembersPagination() {
            this.fetchMembersList(((this.membersPagination && this.membersPagination.page) || 0) + 1);
        },
        removeTeamMember(id, block) {
            block.members = block.members.filter((m) => m.teamMemberId !== id);
        },
        moveItem({ from, to }, block) {
            const list = [...block.members];
            if (from < 0 || to < 0 || from >= list.length || to >= list.length) return;
            const [movedItem] = list.splice(from, 1);
            list.splice(to, 0, movedItem);
            block.members = list;
        },
        async generateMemberChoice(member, block) {
            const id = member.teamMemberId;
            const type = "member";
            const blockId = block.id;

            const cachedResponse = this.$store.state.aiResponses[`${type}-${id}`];
            if (cachedResponse) {
                member.whyTeamMember = cachedResponse;
                return;
            }

            if (!member.whyTeamMember) {
                const prompt = `Write a concise "Why Choose" section for a resume. The candidate's name is ${member.teamMemberName} and his role is ${member.role}. In 1–2 professional sentences (maximum 450 characters), explain why an employer should select him by summarizing his primary responsibilities, relevant experience, and key skills. Maintain a factual, objective tone similar to a job description or professional summary. Avoid marketing language, buzzwords, first-person phrasing, headings, or exaggerated claims.`;

                try {
                    const response = await this.$store.dispatch("generateAIResponseById", { type, id, prompt });
                    if (response) {
                        member.whyTeamMember = response;
                    } else {
                        this.$set(this.memberErrorMessages, blockId, "AI response failed. Please try again.");
                        setTimeout(() => { this.$set(this.memberErrorMessages, blockId, ""); }, 3000);
                    }
                } catch (error) {
                    console.error("AI Generation failed:", error);
                    this.$set(this.memberErrorMessages, blockId, "AI response failed. Please try again.");
                    setTimeout(() => { this.$set(this.memberErrorMessages, blockId, ""); }, 3000);
                }
            }
        },
        handleMembersSelection(selectedIds, block) {
            const existingMembers = block.members || [];
            block.members = selectedIds.map((id) => {
                const existing = existingMembers.find((m) => m.teamMemberId === id);
                if (existing) return existing;

                const member = this.members.find((m) => m.teamMemberId === id);
                if (!member) return null;

                const cachedResponse = this.$store.state.aiResponses[`member-${id}`];

                const newMember = {
                    ...member,
                    projects: [],
                    whyTeamMember: cachedResponse || member.whyTeamMember || "",
                };

                if (!newMember.whyTeamMember && (block.template == 1 || block.template == 3)) {
                    this.generateMemberChoice(newMember, block);
                }
                return newMember;
            }).filter(Boolean);
        },
        getTemplateStyle(t) {
            return {
                colorScheme: {
                    header: t == 5 || t == 6 ? "#001b3c" : t == 7 ? "#002b61" : "#545454",
                    body: t == 5 || t == 6 ? "#001b3c" : t == 7 ? "#c49508" : "#e3e3e4",
                    footer: t == 5 || t == 6 ? "#001b3c" : t == 7 ? "#ffffff" : "#545454",
                    nameSec: "#e66e2d",
                    expSec: "#373236",
                },
                heading: {
                    color: t == 5 || t == 6 ? "#001b3c" : t == 7 ? "#ffffff" : "#000000",
                    size: t == 5 || t == 6 ? "32" : t == 7 ? "24" : "14",
                    font: "Arial",
                    bold: t == 5 || t == 6 || t == 7 ? false : true,
                    italic: false,
                    underline: false,
                },
                label: {
                    color: t == 5 || t == 6 ? "#001b3c" : t == 7 ? "#00386d" : "#000000",
                    size: t == 5 || t == 6 ? "14" : "12",
                    font: "Arial",
                    bold: t == 5 || t == 6 ? false : true,
                    italic: false,
                    underline: false,
                },
                text: {
                    color: "#000000",
                    size: "12",
                    font: "Arial",
                    bold: false,
                    italic: false,
                    underline: false,
                },
            };
        },
        fixStyling(block) {
            const match = this.TemplateList.find(item => item.value === block.template);
            if (match) block.style = match.style;
        },
        handleTemplateSelection(selectedTemplate, block) {
            block.template = selectedTemplate;
            if (selectedTemplate === 3 || selectedTemplate === 4 || selectedTemplate === 6) {
                block.members = (block.members || []).slice(0, 2);
                block.members.forEach(member => {
                    member.projects = (member.projects || []).slice(0, 3);
                });
            }
            if (selectedTemplate == 7) {
                block.projectsPerPage = 8;
            }
            this.fixStyling(block);
        },
        async summarizeProject(project, block) {
            const id = project.projectId;
            const type = "project";
            const blockId = block.id;
            const currentDetails = project.projectDetails || "";

            if (!currentDetails || currentDetails.length > 200) {
                const cachedResponse = this.$store.state.aiResponses[`${type}-${id}`];

                if (cachedResponse && cachedResponse.length <= 200) {
                    project.projectDetails = cachedResponse;
                } else {
                    let promptText = "";
                    if (!currentDetails) {
                        promptText = `Write a concise project scope description for the project "${project.projectName}". In 1–2 professional sentences (maximum 200 characters), describe the scope of work the team was responsible for, including key objectives, responsibilities, and outcomes. Keep the tone factual and objective, suitable for a resume or project experience section. Avoid marketing language, promotional wording, headings, or exaggerated claims.`;
                    } else {
                        promptText = `Summarize the following project details for the project "${project.projectName}" to be close to and maximum 200 characters while maintaining a professional, objective tone: ${currentDetails}`;
                    }
                    try {
                        const response = await this.$store.dispatch("generateAIResponseById", { type, id, prompt: promptText });
                        if (response) {
                            project.projectDetails = response;
                        } else {
                            this.$set(this.projectErrorMessages, blockId, "AI response failed. Please try again.");
                            setTimeout(() => { this.$set(this.projectErrorMessages, blockId, ""); }, 3000);
                        }
                    } catch (error) {
                        console.error("AI Generation failed:", error);
                        this.$set(this.projectErrorMessages, blockId, "AI response failed. Please try again.");
                        setTimeout(() => { this.$set(this.projectErrorMessages, blockId, ""); }, 3000);
                    }
                }
            }
        },
        handleProjectSelection(newProjects, memberId, block) {
            block.members = block.members.map((member) => {
                if (member.teamMemberId === memberId) {
                    const updatedProjects = newProjects.map(p => ({ ...p }));

                    const existingProjectIds = new Set((member.projects || []).map(p => p.projectId));
                    const newlyAddedProjects = updatedProjects.filter(p => !existingProjectIds.has(p.projectId));

                    newlyAddedProjects.forEach(project => {
                        if (!project.projectDetails || project.projectDetails.length > 200) {
                            this.summarizeProject(project, block);
                        }
                    });
                    return { ...member, projects: updatedProjects };
                }
                return member;
            });
        },
        async generateTeamMemberDescriptions(block) {
            const blockId = block.id;
            if (this.isGeneratingMembers[blockId]) return;
            this.$set(this.isGeneratingMembers, blockId, true);

            try {
                for (const member of block.members) {
                    if (!member.whyTeamMember) {
                        const id = member.teamMemberId;
                        const type = "member";
                        const promptText = `Write a concise introduction section for a resume highlighting his role. The candidate's name is ${member.teamMemberName} and his role is ${member.role}. In 1–2 professional sentences (maximum 450 characters), explain why an employer should select him by summarizing his primary responsibilities, relevant experience, and key skills. Maintain a factual, objective tone similar to a job description or professional summary. Avoid marketing language, buzzwords, first-person phrasing, headings, or exaggerated claims.`;

                        const response = await this.$store.dispatch("generateAIResponseById", { type, id, prompt: promptText });
                        if (response) {
                            member.whyTeamMember = response;
                        } else {
                            this.$set(this.memberErrorMessages, blockId, "AI response failed. Please try again.");
                            setTimeout(() => { this.$set(this.memberErrorMessages, blockId, ""); }, 3000);
                        }
                    }
                }
            } catch (error) {
                console.error("Batch generation for members failed:", error);
                this.$set(this.memberErrorMessages, blockId, "AI response failed. Please try again.");
                setTimeout(() => { this.$set(this.memberErrorMessages, blockId, ""); }, 3000);
            } finally {
                this.$set(this.isGeneratingMembers, blockId, false);
            }
        },
        addBlock() {
            if (!this.proposal.resume.blocks) {
                this.$set(this.proposal.resume, 'blocks', []);
            }
            const newBlock = {
                id: "block_" + Date.now(),
                template: "",
                style: null,
                projectsPerPage: 6,
                members: [],
            };
            this.proposal.resume.blocks.push(newBlock);
            this.expandedBlockId = newBlock.id;
        },
        removeBlock(index) {
	        let content = {
		      titleText: 'Confirm Delete',
		      message1: `Are you sure you want to remove the block?`		
	         };
	        let cm = util.fn_getModal_confirm(this, content);

	        this.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then((resp) => {
		    if (!resp) return;
                this.proposal.resume.blocks.splice(index, 1);
          });
    }
    }
};
</script>

<template>
  <div class="d-flex flex-column w-100 bg-white rounded-lg text-left">
    <div class="d-flex flex-column">
      <h4 class="mb-3 font-weight-bold">Members Resume</h4>
      <div class="row">
        <div class="col-12 mb-3">
          <InputField label="Page Title" :model-value="proposal.resume.title" placeholder="Enter Page Title"
            @update:modelValue="proposal.resume.title = $event" />
        </div>
      </div>

      <div v-for="(block, bIdx) in proposal.resume.blocks" :key="block.id || bIdx"
        class="block-container border mb-4 rounded">
        <div class="d-flex justify-content-between align-items-center p-3 cursor-pointer bg-light"
          @click="expandedBlockId = (expandedBlockId === block.id ? null : block.id)">
          <h5 class="mb-0 font-weight-bold">Template Block {{ bIdx + 1 }}</h5>

          <div class="d-flex align-items-center justify-content-center">
            <AppButton v-if="proposal.resume.blocks && proposal.resume.blocks.length > 1" variant="danger" size="sm"
              @click.stop="removeBlock(bIdx)" class="btn-delete" variant="danger" title="Remove block">
              <fa-icon icon="trash-alt" />
            </AppButton>

            <span class="expanded-icon"
              :style="{ transform: expandedBlockId === block.id ? 'rotate(180deg)' : 'rotate(0deg)' }">
              <span v-html="arrowDownIcon"></span>
            </span>
          </div>
        </div>

        <div v-show="expandedBlockId === block.id" class="p-3 border-top">
          <div class="row">
            <div class="col-12 mb-3">
              <SelectDropdown label="Template" :modelValue="block.template"
                :options="TemplateList.filter(item => item.orientation === proposal.pageOrientation)"
                placeholder="Select Template" @update:modelValue="(val) => handleTemplateSelection(val, block)"
                :isPreviewable="true" />
            </div>
          </div>

          <div v-if="block.template" class="row">
            <div class="col-12 col-md-6 mb-3">
              <SelectDropdown label="Members" :modelValue="(block.members || []).map((p) => p.teamMemberId)"
                :options="membersList" :multi="true"
                :maxSelection="block.template === 3 || block.template === 4 ? 2 : Infinity" placeholder="Select Members"
                @update:modelValue="(val) => handleMembersSelection(val, block)" :loading="MembersLoading"
                :canPaginate="canPaginateMembers" @handlePagination="handleMembersPagination" :showSearch="true"
                :searchQuery.sync="memberSearchQuery" :disabled="!block.template" />
            </div>
            <div v-if="block.template !== 3 && block.template !== 4 && block.template !== 6"
              class="col-12 col-md-6 mb-3">
              <SelectDropdown label="Projects Per Page" :modelValue="block.projectsPerPage"
                :options="block.template === 7 ? [1, 2, 3, 4, 5, 6, 7, 8] : [1, 2, 3, 4, 5, 6]" placeholder="# Projects"
                @update:modelValue="block.projectsPerPage = $event"
                :disabled="!block.template || block.template === 3 || block.template === 4 || block.template === 6" />
            </div>
          </div>

          <div v-if="block.template && block.members && block.members.length > 0" class="row">
            <div class="col-12 col-md-6 mb-3">
              <div class="d-flex flex-column">
                <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center mb-1">
                  <label class="label">Selected Team Members</label>
                  <div v-if="block.template == 1 || block.template == 3" class="d-flex justify-content-end">
                    <AppButton variant="primary" size="sm" class="ml-1" @click="generateTeamMemberDescriptions(block)"
                      :disabled="isGeneratingMembers[block.id]">
                      {{ isGeneratingMembers[block.id] ? 'Generating...' : 'Generate All' }}
                    </AppButton>
                  </div>
                </div>
              </div>
              <InfoCard :list="block.members" @remove-item="(id) => removeTeamMember(id, block)"
                @move-item="(ev) => moveItem(ev, block)" idKey="teamMemberId" labelKey="teamMemberName"
                :isAI="block.template == 1 || block.template == 3 || block.template == 5 || block.template == 6 || block.template == 7"
                @update="block.members = [...$event]" :textLimit="450" context="resume" />

              <p class="error-message" v-if="memberErrorMessages[block.id]">{{ memberErrorMessages[block.id] }}</p>
            </div>

            <div class="col-12 col-md-6 mb-3">
              <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center mb-1">
                <label class="label">Selected Resume Projects</label>
              </div>
              <div class="d-flex flex-column gap-4">
                <div class="project-trigger" v-for="member in block.members" :key="member.teamMemberId"
                  :class="{ 'missing-projects': !member.projects.some(p => $store.state.loading.aiGenerateById[`project-${p.projectId}`]) && (member.projects.length === 0 || member.projects.some(p => (p.projectDetails || '').length > 200)) }">
                  <div class="d-flex justify-content-between align-items-center" role="button"
                    @click="toggleMember(member.teamMemberId)">
                    <p class="member-name">{{ `${member.teamMemberName} Projects` }}</p>
                    <span v-html="arrowDownIcon" class="searchable-dropdown-arrow"
                      :class="{ open: expandedMemberId === member.teamMemberId }" />
                  </div>
                  <div class="border-top mt-1 pt-2" v-show="expandedMemberId === member.teamMemberId">
                    <ProjectsDropdown :modelValue="member.projects"
                      :maxSelection="block.template === 3 || block.template === 4 || block.template === 6 ? 3 : Infinity"
                      @update:modelValue="(newProjects) => handleProjectSelection(newProjects, member.teamMemberId, block)"
                      :memberId="member.teamMemberId" :isAI="true" :textLimit="200" context="resume" />
                  </div>
                </div>
                <p class="error-message" v-if="projectErrorMessages[block.id]">{{ projectErrorMessages[block.id] }}</p>
              </div>
            </div>
          </div>

          <div class="row" v-if="block.template && block.style">
            <div v-for="item in [
              { key: 'colorScheme', label: 'Color Scheme' },
              { key: 'heading', label: 'Heading Color' },
              { key: 'label', label: 'Label Color' },
              { key: 'text', label: 'Text Color' }
            ]" :key="item.key" class="col-12 col-md-6 col-lg-3 mb-3">
              <ColorSchemeBox v-if="item.key === 'colorScheme'" :styling="block.style[item.key]" :label="item.label"
                :colorScheme="[1, 2, 3, 4].includes(block.template) ? ['header', 'body', 'nameSec', 'expSec', 'footer'] : ['header', 'body', 'footer']" />
              <StyleBox v-else :styling="block.style[item.key]" :label="item.label" />
            </div>
          </div>
        </div>
      </div>

      <div class="mb-4 d-flex justify-content-center">
        <AppButton variant="none" class="btn-add-pill icon" title="Add a block" @click="addBlock()">
          <fa-icon icon="plus" style="color:green;" />Add a block
        </AppButton>
      </div>
	  
    </div>

    <PreviewTemplates :isPreviewable="isPreviewable" :emptyMessage="previewText">
      <div v-for="(block, bIdx) in proposal.resume.blocks" :key="block.id || bIdx" class="resume-preview-wrapper">
        <ResumeTemp1 v-if="block.template === 1" :resume="block" />
        <ResumeTemp2 v-if="block.template === 2" :resume="block" />
        <ResumeTemp3 v-if="block.template === 3" :resume="block" />
        <ResumeTemp4 v-if="block.template === 4" :resume="block" />
        <ResumeTemp5 v-if="block.template === 5" :resume="block" />
        <ResumeTemp6 v-if="block.template === 6" :resume="block" />
        <ResumeTemp7 v-if="block.template === 7" :resume="block" />
      </div>
    </PreviewTemplates>
  </div>
</template>

<style scoped lang="scss">
.cursor-pointer {
  cursor: pointer;
}

.gap-20 {
  gap: 20px;
}

.expanded-icon {
  display: inline-flex;
  transition: transform 0.3s ease;
  align-items: center;
  margin-left: 10px;
  justify-content: center;
}

.label {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0px;
}

.gap-4 {
  gap: 4px;
}

.missing-projects {
  border: 1px solid #dc3545 !important;
  background: #fff8f8;
}

.project-trigger {
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  font-size: 13px;
  padding: 4px 10px;
  margin: 0px;

  .member-name {
    margin: 5.25px 0px;
  }
}

.searchable-dropdown-arrow {
  margin-left: 8px;
  transition: transform 0.2s;
  font-size: 12px;
  padding: 2px 0px;
  color: #999;
  flex-shrink: 0;

  &.open {
    transform: rotate(180deg);
  }
}

.error-message {
  color: #ff4444;
  font-size: 12px;
}

.resume-preview-wrapper {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0px;
  }
}
.btn-delete {
    color: #dc3545;
    text-align: center;
    font-size: 0.8em;
    width: 23px;
    padding: 0.1em 0;
    margin: 0.25em 0;
    margin-left: 0.5em;
    border: none;
    background: transparent;
    cursor: pointer;
    transition: color 0.2s ease, transform 0.15s ease;
}

.btn-delete:hover {
    color: #a71d2a;        /* slightly darker red */
    text-decoration: underline;
    transform: scale(1.15); /* subtle emphasis */
}
.btn-add-block-card {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 18px;
  background: #ffffff;
  border: 1px dashed #b5b5b5;
  border-radius: 8px;
  font-size: 15px;
  color: #444;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  transition: all 0.2s ease;
}

.btn-add-block-card .icon {
  color: #28a745;
  font-size: 18px;
  font-weight: bold;
}

.btn-add-block-card:hover {
  border-color: #28a745;
  background: #f8fff9;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
}
.btn-add-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  background: #e8f8ee;
  border: none;
  border-radius: 50px;
  font-size: 14px;
  color: #1f7a3a;
  cursor: pointer;
  transition: background 0.2s ease;
}

.btn-add-pill .icon {
  font-size: 16px;
  font-weight: bold;
}

.btn-add-pill:hover {
  background: #dff5e7;
}
</style>